import { Injectable } from '@angular/core';
import { AdminService } from '@nice-devone/core-sdk';
import { LoggerService } from 'src/app/core/services/logger.service';

@Injectable({ providedIn: 'root' })
export class SendReloadScreenSignalService {
  constructor(private logger: LoggerService) {}

  private readonly interactionKeyInLocalStorage = 'reload-sesion:interactionId';

  setInteractionIdInLocalStorage(interactionId: string): void {
    localStorage.setItem(this.interactionKeyInLocalStorage, interactionId);
  }

  getInteractionIdInLocalStorage(): string | null {
    return localStorage.getItem(this.interactionKeyInLocalStorage);
  }

  removeInteractionIdInLocalStorage(): void {
    localStorage.removeItem(this.interactionKeyInLocalStorage);
  }

  interactionIdExist() {
    const interactionExist = !!this.getInteractionIdInLocalStorage();
    return interactionExist;
  }

  sendReloadSignal() {
    const idInteracao = this.getInteractionIdInLocalStorage();

    if (idInteracao) {
      try {
        AdminService.instance.signalScript(idInteracao, { p1: 'F5' });
        this.logger.warn(' signal enviado: fechamento indevido', idInteracao);
      } catch (error) {
        console.log('erro ao enviar signal', error);
      }
    }
  }
}
